import React     from 'react';
import ThemeSettings, { Theme } from '../../../../theme';
import classNames from 'classnames';
import styles from './Box.css';

export type BoxProps = {
    as?: string;
    elevated?: boolean;
    justify?: string;
    align?: string;
    direction?: string;
    wrap?: string;
    width?: string;
    height?: string;
    children?: any;
    padding?: string;
    paddingT?: string;
    paddingB?: string;
    paddingL?: string;
    theme?: Theme;
    position?: string;
    margin?: string;
    className?: string;
};

export const Box = React.memo(({
    as, position, elevated, margin, className,
    align, direction, justify, wrap, padding, paddingT, paddingL, paddingB,
    ...props
}: BoxProps) => {
    const Component: any = as || 'div';

    return (
        <Component
            className = {classNames(
                styles.base,
                {
                    [styles[`${position}Position`]]: !!position,
                    [styles.elevated]: !!elevated
                },
                className
            )}

            style = {{
                flexDirection: direction || undefined,
                alignItems: align || undefined,
                justifyContent: justify || undefined,
                margin: margin || undefined,
                flexWrap: wrap || 'nowrap',
                padding: padding || undefined,
                paddingTop: ThemeSettings.spacing[paddingT] || undefined,
                paddingLeft: ThemeSettings.spacing[paddingL] || undefined,
                paddingBottom: ThemeSettings.spacing[paddingB] || undefined
            }}

            {...props}
        />
    );
});

Box.displayName = 'Box';
